<template>
  <div id="shift_area" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>排班區域管理</h3>
          <hr />
        </div>
      </div>
    </div>
    <el-row :gutter="8">
      <el-col :span="2">
        <h4>排班站:</h4>
      </el-col>
      <el-col :span="6">
        <select
          class="inputstyle"
          v-model="select.shift_area_id"
          v-on:change="onShiftAreaChange(select.shift_area_id)"
        >
          <option value="insert">新增</option>
          <option
            v-for="station in options.shift_area_arr"
            :value="station.id"
            :key="station.id"
          >
            {{ station.name }}
          </option>
        </select>
      </el-col>
      <el-col :span="2">
        <h4>派遣區派遣區:</h4>
      </el-col>
      <el-col :span="6">
        <select
          class="inputstyle"
          v-model="select.dispatch_area_id"
          v-on:change="onDispatchAreaChange(select.dispatch_area_id)"
        >
          <option value="insert">--請選擇--</option>
          <option
            v-for="station in options.dispatch_area_arr"
            :value="station.id"
            :key="station.id"
          >
            {{ station.name }}
          </option>
        </select>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="16">
        <div id="map" class="mapblocklarge">Google map</div>
      </el-col>
      <el-col :span="8" style="border: 2px solid; padding: 16px">
        <el-row :gutter="8">
          <el-form ref="form" label-width="100px" size="mini">
            <el-form-item label="匯入圖資">
              <a href="javascript:;" class="mybtnstyle btn-dark file">
                匯入圖資
                <input
                  id="upload"
                  v-on:change="onFileChange"
                  type="file"
                  name=""
                />
              </a>
              <span style="color: red">*</span>
              <span v-if="file">{{ file.name }}</span>
            </el-form-item>
            <el-form-item v-if="kmlCreatedDate" label="建立日期">
              <span style="font-size: 1.8rem">
                {{ kmlCreatedDate }}
              </span>
            </el-form-item>
            <el-form-item label="排班站名稱">
              <input
                v-model="shift_area.name"
                type="text"
                required="required"
                class="inputstyle fontSize16 main_title"
              />
            </el-form-item>
            <el-form-item label="車數容量">
              <input
                v-model="shift_area.area_capacity"
                min="1"
                step="1"
                type="number"
                required="required"
                class="inputstyle fontSize16"
              />
            </el-form-item>
            <el-form-item label="排班站類型">
              <select class="inputstyle col-md-7" v-model="shift_area.type">
                <option
                  v-for="option in options.type_options"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </el-form-item>
            <el-form-item label="服務 (打勾為 '是'):">
              <driver-service-checkbox
                ref="driverServiceList"
              ></driver-service-checkbox>
            </el-form-item>
            <el-form-item label="排班時間1:">
              <el-col :span="11">
                <el-select
                  v-model="shift_area.in_line_time1_start"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="(value, key) in options.time_options"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-select
                v-model="shift_area.in_line_time1_end"
                placeholder="請選擇"
              >
                <el-option
                  v-for="(value, key) in options.time_options"
                  :key="key"
                  :label="key"
                  :value="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="排班時間2:"
              v-if="
                this.shift_area.in_line_time1_end !== null &&
                this.shift_area.in_line_time1_start !== null
              "
            >
              <el-col :span="11">
                <el-select
                  v-model="shift_area.in_line_time2_start"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="(value, key) in options.time_options"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-select
                v-model="shift_area.in_line_time2_end"
                placeholder="請選擇"
              >
                <el-option
                  v-for="(value, key) in options.time_options"
                  :key="key"
                  :label="key"
                  :value="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="備註:">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="請輸入內容"
                v-model="shift_area.note"
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <el-form-item size="large">
              <el-form-item v-if="permisionScheduledArea">
                <el-button
                  size="medium"
                  v-if="select.shift_area_id == 'insert'"
                  type="success"
                  @click="onInsertBtnClick"
                >
                  新增
                </el-button>
                <el-button
                  size="medium"
                  v-if="select.shift_area_id !== 'insert'"
                  type="primary"
                  @click="onUpdateBtnClick"
                >
                  更新
                </el-button>
                <el-button
                  size="medium"
                  v-if="select.shift_area_id !== 'insert'"
                  type="danger"
                  @click="onDeleteBtnClick"
                >
                  刪除
                </el-button>
              </el-form-item>
            </el-form-item>
          </el-form>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'
import dayjs from 'dayjs'
import { ApiKey } from '@/assets/js/libs/GoogleAPI'
import { Notification } from 'element-ui'
import { cookies } from '@/utils/cookies'
import ShiftArea from '@/assets/js/libs/Shift_area'
import Group from '@/assets/js/libs/Group'
import GoogleMapsLoader from 'google-maps'
import driverServiceCheckbox from '@/components/driver/DriverServiceCheckBox_1'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import { getAdminAuthorization } from '@/assets/js/tool/adminAuth'

const shiftArea = new ShiftArea()
const group = new Group()

export default {
  name: 'ShiftArea',
  components: {
    driverServiceCheckbox,
  },
  data() {
    return {
      options: {
        dispatch_area_arr: [],
        shift_area_arr: [],
        time_options: shiftArea.getTimeOptions(),
        driver_groups: [],
        service_groups: group.getServiceGroups(),
        type_options: [
          { value: 'comprehensive', label: '通用' },
          { value: 'normal', label: '一般計程車' },
          { value: 'multiple', label: '多元計程車' },
        ],
      },
      dispatch_area: {},
      shift_area: {
        name: null,
        area_capacity: 100,
        type: 'comprehensive',
        specific_groups: null,
        in_line_time1_start: null,
        in_line_time2_start: null,
        in_line_time1_end: null,
        in_line_time2_end: null,
        note: null,
      },
      originShiftArea: {},
      originServiceList: [],
      shift_area_kml: null,
      select: {
        dispatch_area_id: 'insert',
        shift_area_id: 'insert',
      },
      file: null,
      map: {
        shift_area: null,
        dispatch_area: null,
      },
      kmlSchedualArray: [],
      kmlSchedualParser: null,
      kmlParser: null,
      kmlArray: [],
      kmlUpload: [],
      customerServiceArray: [],
    }
  },
  computed: {
    permisionScheduledArea() {
      return getAdminAuthorization('scheduledArea') === 2
    },
    kmlCreatedDate() {
      return this.shift_area.createdAt
        ? dayjs(this.shift_area.createdAt).format('YYYY-MM-DD HH:mm')
        : null
    },
  },
  methods: {
    resetForm() {
      this.shift_area = {
        name: null,
        area_capacity: 100,
        type: 'comprehensive',
        specific_groups: null,
        in_line_time1_start: null,
        in_line_time2_start: null,
        in_line_time1_end: null,
        in_line_time2_end: null,
        note: null,
      }
      this.kmlSchedualArray = []
      this.kmlUpload = []
      this.file = null
    },
    onShiftAreaChange(id) {
      if (id === 'insert') {
        this.resetForm()
        this.select.shift_area_id = 'insert'
        this.reloadKml()
      } else {
        this.kmlSchedualParser = new geoXML3.parser({
          map: this.map.shift_area,
          singleInfoWindow: true,
        })
        API.get(`/shift-area/?id=${id}`)
          .then((res) => {
            if (!res || !res.kmlFile) {
              Notification({
                title: '無法取得排班站資料',
                type: 'error',
              })
              return
            }
            localStorage.setItem(`schedualed-${id}`, res.kmlFile)
            // 先清除服務，然後等待組件準備好再設置
            this.$refs.driverServiceList.clearService()
            if (res.result && res.result.specific_groups !== null) {
              var arr = res.result.specific_groups.split(',').map(function (x) {
                var id = isNaN(Number(x)) ? x : Number(x)
                return { serivceId: id }
              })
              // 使用雙重 nextTick 確保組件已完全更新
              this.$nextTick(() => {
                this.$nextTick(() => {
                  this.$refs.driverServiceList.setfillOutServiceListCheckBox(
                    arr,
                  )
                })
              })
            }
            this.shift_area = res.result || {}
            this.originShiftArea = JSON.parse(JSON.stringify(this.shift_area))
            this.originServiceList =
              res.result && res.result.specific_groups
                ? res.result.specific_groups.split(',').map(function (x) {
                    return isNaN(Number(x)) ? x : Number(x)
                  })
                : []

            try {
              const parser = new DOMParser()
              const xmlDoc = parser.parseFromString(
                localStorage.getItem(`schedualed-${id}`),
                'text/xml',
              )

              const coordinatesElement = xmlDoc.querySelector('coordinates')
              if (!coordinatesElement || !coordinatesElement.textContent) {
                Notification({
                  title: 'KML 檔案格式錯誤',
                  type: 'error',
                })
                return
              }

              const points = coordinatesElement.textContent
                .trim()
                .replace(/\r?\n|\r/g, '')
                .split(',')

              if (points.length < 2) {
                Notification({
                  title: 'KML 座標資料不完整',
                  type: 'error',
                })
                return
              }

              const LatLng = {
                lat: Number(points[1]),
                lng: Number(points[0]),
              }

              if (isNaN(LatLng.lat) || isNaN(LatLng.lng)) {
                Notification({
                  title: 'KML 座標資料格式錯誤',
                  type: 'error',
                })
                return
              }

              if (this.kmlSchedualArray.includes(res.kmlFile)) {
                /* 移動座標，不需要產生新的圖檔 */
                this.map.shift_area.setCenter({
                  lat: LatLng.lat,
                  lng: LatLng.lng,
                })
                return
              }

              this.kmlSchedualParser.parseKmlString(
                localStorage.getItem(`schedualed-${id}`),
              )
              this.kmlSchedualArray.push(
                localStorage.getItem(`schedualed-${id}`),
              )
            } catch (error) {
              console.error('KML 解析錯誤:', error)
              Notification({
                title: 'KML 檔案解析失敗',
                type: 'error',
              })
            }
          })
          .catch((err) => {
            console.error('API 請求錯誤:', err)
            Notification({
              title: '無法取得排班站資料',
              type: 'error',
            })
          })
      }
    },
    updateArea() {
      // all-area update
      API.get(`/shift-area/all-area`)
        .then((res) => {
          let allArea = res.allArea
          let AreaNumber = []
          for (let i = 0; i < allArea.length; i++) {
            localStorage.setItem(`schedualed-${allArea[i].id}`, allArea[i].kml)
            AreaNumber.push(allArea[i].identification_code)
          }
          localStorage.setItem('AreaNumber', AreaNumber.join())
        })
        .catch((err) => {
          alert(err)
        })
    },
    onDispatchAreaChange(id) {
      this.kmlParser = new geoXML3.parser({
        map: this.map.shift_area,
        singleInfoWindow: true,
      })
      API.get(`/dispatch-area/?id=${id}`)
        .then((res) => {
          localStorage.setItem(`dispatch-${id}`, res.kmlFile)
          this.dispatch_area = res.result
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(
            localStorage.getItem(`dispatch-${id}`),
            'text/xml',
          )
          const LatLng = {
            lat: Number(
              xmlDoc
                .getElementsByTagName('coordinates')[0]
                .childNodes[0].nodeValue.trim()
                .split(',')[1],
            ),
            lng: Number(
              xmlDoc
                .getElementsByTagName('coordinates')[0]
                .childNodes[0].nodeValue.trim()
                .split(',')[0],
            ),
          }
          if (this.kmlArray.includes(res.kmlFile)) {
            // 移動座標，不需要產生新的圖檔
            this.map.shift_area.setCenter({
              lat: LatLng.lat,
              lng: LatLng.lng,
            })
            return
          }

          this.kmlParser.parseKmlString(localStorage.getItem(`dispatch-${id}`))
          this.kmlArray.push(localStorage.getItem(`dispatch-${id}`))
        })
        .catch((err) => {
          alert(err + '錯誤碼:002')
        })
    },
    isInsertOption(option) {
      return option != 'insert'
    },
    onFileChange(e) {
      const fileReader = new FileReader()
      const files = e.target.files
      this.file = files[0]
      fileReader.onload = async (e) => {
        if (this.kmlSchedualParser === null) {
          this.kmlSchedualParser = new geoXML3.parser({
            map: this.map.shift_area,
            singleInfoWindow: true,
          })
        }
        if (this.kmlUpload.includes(e.target.result)) {
          // 解析是否有重複
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(e.target.result, 'text/xml')
          const LatLng = {
            lat: Number(
              xmlDoc
                .getElementsByTagName('coordinates')[0]
                .childNodes[0].nodeValue.trim()
                .split(',')[1],
            ),
            lng: Number(
              xmlDoc
                .getElementsByTagName('coordinates')[0]
                .childNodes[0].nodeValue.trim()
                .split(',')[0],
            ),
          }
          this.map.shift_area.setCenter({
            lat: LatLng.lat,
            lng: LatLng.lng,
          })
          return
        }
        this.kmlSchedualParser.parseKmlString(e.target.result)
        this.kmlUpload.push(e.target.result)
      }
      fileReader.readAsText(this.file, 'utf-8')
    },
    isValidData() {
      const data = this.shift_area
      if (!data.name || data.name.trim() === '') {
        Notification({
          title: '請輸入排班站名稱',
          type: 'error',
        })
        return false
      }

      if (data.area_capacity === null || data.area_capacity <= 0) {
        Notification({ title: '請輸入車數容量', type: 'error' })
        return false
      }

      if (
        data.in_line_time1_start === null ||
        data.in_line_time1_end === null
      ) {
        Notification({ title: '請輸入排班時間', type: 'error' })
        return false
      }

      return true
    },
    async onInsertBtnClick() {
      BehaviorRecorder.record(
        '點擊',
        '排班站',
        `新增排班站(${this.shift_area.name})`,
      )

      if (!this.file) {
        Notification({ title: '請上傳排班站圖檔', type: 'error' })
        return
      }

      if (!this.isValidData()) {
        return
      }

      try {
        const result = await shiftArea.create(this.formatData())
        if (result.success) {
          this.resetForm()
          this.updateIdentificaitonCode()
          this.onShiftAreaChange('insert')
          Notification({
            title: '新增成功',
            type: 'success',
          })
        } else {
          if (result.message !== 'Validation failed') {
            Notification({
              title: '新增失敗',
              type: 'error',
            })
          }
        }
      } catch (e) {
        if (e.message !== 'Validation failed') {
          console.error(e)
          Notification({
            title: '新增失敗',
            type: 'error',
          })
        }
      }
    },
    async onDeleteBtnClick() {
      try {
        const shiftAreaName = this.options.shift_area_arr.find(
          (shiftArea) => shiftArea.id === this.select.shift_area_id,
        ).name
        BehaviorRecorder.record(
          '點擊',
          '排班站',
          `刪除排班站(${shiftAreaName})`,
        )
        const { success } = await shiftArea.delete(this.select.shift_area_id)
        if (success) {
          this.updateIdentificaitonCode()
          this.onShiftAreaChange('insert')
          Notification({
            title: '刪除成功',
            type: 'success',
          })
        } else {
          Notification({
            title: '刪除失敗',
            type: 'error',
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          title: '刪除失敗',
          type: 'error',
        })
      }
    },
    async onUpdateBtnClick() {
      const task = this.file ? 'updateFile' : 'updateInfo'
      const shiftAreaName = this.options.shift_area_arr.find(
        (shiftArea) => shiftArea.id === this.select.shift_area_id,
      ).name

      if (!this.isValidData()) {
        return
      }

      try {
        const result = await shiftArea.update(
          this.select.shift_area_id,
          task,
          this.formatData(),
        )
        if (result.success) {
          if (this.file) {
            console.log('有更新地圖')
            BehaviorRecorder.record(
              '點擊',
              '排班站',
              `<${shiftAreaName}> 重新上傳圖資`,
            )
          }
          this.updateShiftAreaRecord()
          this.file = null
          this.updateIdentificaitonCode()
          this.onShiftAreaChange(this.select.shift_area_id)
          Notification({
            title: '更新成功',
            type: 'success',
          })
        } else {
          Notification({
            title: '更新失敗',
            type: 'error',
          })
        }
      } catch (e) {
        if (e.message !== 'Validation failed') {
          console.error(e)
          Notification({
            title: '更新失敗',
            type: 'error',
          })
        }
      }
    },
    checkTimeRange(start, end) {
      let _startTime = start.split(':')
      let _endTime = end.split(':')
      let startDate = new Date(
        0,
        0,
        0,
        _startTime[0],
        _startTime[1],
        _startTime[2],
      )
      let endDate = new Date(0, 0, 0, _endTime[0], _endTime[1], _endTime[2])
      return startDate <= endDate
    },
    checkTimeRepeat(start, end, time) {
      let _startTime = start.split(':')
      let _endTime = end.split(':')
      let _time = time.split(':')
      let startDate = new Date(
        0,
        0,
        0,
        _startTime[0],
        _startTime[1],
        _startTime[2],
      )
      let endDate = new Date(0, 0, 0, _endTime[0], _endTime[1], _endTime[2])
      let date = new Date(0, 0, 0, _time[0], _time[1], _time[2])
      return startDate < date && date < endDate
    },
    initMap() {
      const lat = parseFloat(cookies.get('GladAddressGps').coordinates[1])
      const lng = parseFloat(cookies.get('GladAddressGps').coordinates[0])
      this.map.shift_area = undefined
      this.map.shift_area = new google.maps.Map(
        document.getElementById('map'),
        {
          center: new google.maps.LatLng(lat, lng),
          gestureHandling: 'greedy',
          zoom: 12,
          mapTypeId: 'roadmap',
        },
      )
    },
    reloadKml() {
      this.initMap()
      const baseUrl = API.getBaseUrl
      const myParser = new geoXML3.parser({
        map: this.map.shift_area,
      })
      if (this.select.shift_area_id !== 'insert')
        myParser.parse(baseUrl + this.shift_area.path)
      if (this.select.dispatch_area_id !== 'insert')
        myParser.parse(baseUrl + this.dispatch_area.path)
    },
    formatData() {
      const param = new FormData()
      param.append('name', this.shift_area.name)
      if (this.file) {
        param.append('file', this.file)
      }
      param.append('area_capacity', this.shift_area.area_capacity)
      this.shift_area.specific_groups = this.$refs.driverServiceList
        .getServiceList()
        .join(',')
      param.append('type', this.shift_area.type)
      param.append(
        'note',
        this.shift_area.note == null ? '' : this.shift_area.note,
      )
      param.append('specific_groups', this.shift_area.specific_groups)
      if (
        this.checkTimeRange(
          this.shift_area.in_line_time1_start,
          this.shift_area.in_line_time1_end,
        )
      ) {
        param.append('in_line_time1_end', this.shift_area.in_line_time1_end)
        param.append('in_line_time1_start', this.shift_area.in_line_time1_start)
      } else {
        return alert('排班時間錯誤')
      }
      /* 判斷排班第二個時間是否有重疊 */
      if (
        this.shift_area.in_line_time2_end &&
        this.shift_area.in_line_time2_start
      ) {
        const start = this.shift_area.in_line_time1_start
        const end = this.shift_area.in_line_time1_end
        if (
          this.checkTimeRepeat(
            start,
            end,
            this.shift_area.in_line_time2_start,
          ) &&
          this.checkTimeRepeat(start, end, this.shift_area.in_line_time2_end)
        ) {
          return alert('第二個排班時間與第一個有重疊(1)')
        } else if (
          this.checkTimeRange(this.shift_area.in_line_time2_start, start) &&
          this.checkTimeRange(end, this.shift_area.in_line_time2_end)
        ) {
          return alert('第二個排班時間與第一個有重疊(2)')
        } else if (
          this.checkTimeRange(this.shift_area.in_line_time2_start, start) &&
          this.checkTimeRepeat(start, end, this.shift_area.in_line_time2_end)
        ) {
          return alert('第二個排班時間與第一個有重疊(3)')
        } else if (
          this.checkTimeRange(end, this.shift_area.in_line_time2_end) &&
          this.checkTimeRepeat(start, end, this.shift_area.in_line_time2_start)
        ) {
          return alert('第二個排班時間與第一個有重疊(4)')
        } else {
          param.append('in_line_time2_end', this.shift_area.in_line_time2_end)
          param.append(
            'in_line_time2_start',
            this.shift_area.in_line_time2_start,
          )
        }
      }
      return param
    },
    updateIdentificaitonCode() {
      API.get(`/dispatch-area/identificaiton-code`)
        .then((res) => {
          let DispatchAreaArray = []
          if (res.err === '無此車隊排班站資料') return
          this.options.dispatch_area_arr = res.result
          let dispatchArea = res.result
          let codeArray = []
          for (let i = 0; i < dispatchArea.length; i++) {
            codeArray.push(dispatchArea[i].identification_code)
            DispatchAreaArray.push(`dispatch-${dispatchArea[i].id}`)
          }
          localStorage.setItem(`DispatchAreaArray`, DispatchAreaArray.join(','))
          localStorage.setItem(`DispatchAreaNumber`, codeArray.join(','))
        })
        .catch((err) => {
          alert(err + '錯誤代碼: area:001')
        })
      API.get(`/shift-area/identificaiton-code`)
        .then((res) => {
          if (res.err === '無此車隊排班站資料') return
          this.options.shift_area_arr = res.result
          let schedualArea = res.result
          let codeArray = []
          let ShiftAreaArray = []

          for (let i = 0; i < schedualArea.length; i++) {
            codeArray.push(schedualArea[i].identification_code)
            ShiftAreaArray.push(`schedualed-${schedualArea[i].id}`)
          }
          localStorage.setItem(`ShiftAreaArray`, ShiftAreaArray.join(','))
          localStorage.setItem(`SchedualAreaNumber`, codeArray.join(','))
        })
        .catch((err) => {
          alert(err + '錯誤代碼: area:001')
        })
    },
    updateShiftAreaRecord() {
      // 組合排班時間1/2
      var oldArea = Object.assign({}, this.originShiftArea)
      var newArea = Object.assign({}, this.shift_area)
      oldArea.in_line_time1 =
        (oldArea.in_line_time1_start || '00:00') +
        '-' +
        (oldArea.in_line_time1_end || '00:00')
      newArea.in_line_time1 =
        (newArea.in_line_time1_start || '00:00') +
        '-' +
        (newArea.in_line_time1_end || '00:00')
      oldArea.in_line_time2 =
        (oldArea.in_line_time2_start || '00:00') +
        '-' +
        (oldArea.in_line_time2_end || '00:00')
      newArea.in_line_time2 =
        (newArea.in_line_time2_start || '00:00') +
        '-' +
        (newArea.in_line_time2_end || '00:00')

      // 服務項目處理
      var oldList = this.originServiceList || []
      var newList = this.$refs.driverServiceList.getServiceList() || []
      var allService = this.$refs.driverServiceList.apiServiceList || []
      function idToNameArr(arr) {
        return arr.map(function (id) {
          var found = allService.find(function (s) {
            return s.id === id
          })
          return found ? found.name : id
        })
      }
      // 只記錄服務異動（格式與司機一致）
      BehaviorRecorder.recordDiffService(
        idToNameArr(oldList),
        idToNameArr(newList),
        {
          title: '修改排班站',
          call_number: this.shift_area.name,
          type: '排班站',
        },
      )

      newArea.call_number = this.shift_area.name
      BehaviorRecorder.recordDiffData(oldArea, newArea, {
        fieldMap: {
          name: '名稱',
          area_capacity: '車數容量',
          type: '排班站類型',
          in_line_time1: '排班時間1',
          in_line_time2: '排班時間2',
          note: '備註',
        },
        extraMap: {
          type: {
            comprehensive: '通用',
            normal: '一般計程車',
            multiple: '多元計程車',
          },
        },
        title: '修改排班站',
        type: '排班站',
      })
    },
  },
  mounted() {
    this.updateIdentificaitonCode()
    GoogleMapsLoader.KEY = ApiKey()
    GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
    GoogleMapsLoader.load(() => {
      this.initMap()
    })
  },
}
</script>

<style scoped>
h4 {
  min-width: 140px;
}

input.inputstyle {
  min-width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/pages/area/ShiftArea.vue